<template>
  <div class="frame9">
    <div class="frame9_options1">
      <img
        src="../../../../public/img/shares_Info/qianshu_logo.png"
        class="frame9_options1_img1"
      />
    </div>
    <div class="frame9_options2">
      <div>
        <img
          src="../../../../public/img/shares_Info/text.png"
          class="frame9_options2_img1"
        />
      </div>
      <div>一站式财商教育平台 你应该知道的赚钱之道</div>
    </div>
    <div class="frame9_options3">
      <div class="frame9_options3_part1">
        <div class="frame9_options3_part1_top">
          <img
            src="../../../../public/img/shares_Info/anzhuo.png"
            alt=""
          />Android下载
        </div>
        <div class="frame9_options3_part1_bottom">
          <img
            src="../../../../public/img/shares_Info/apple.png"
            alt=""
          />AppStore下载
        </div>
      </div>
      <div class="frame9_options3_part2">
        <img
          src="../../../../public/img/shares_Info/erweima2.png"
          alt=""
          class="frame9_options3_img3"
        />
      </div>
      <div class="frame9_options3_part3">
          <img src="../../../../public/img/shares_Info/close.png" alt="" class="frame9_options3_img4" @click="frame9_close">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    frame9_close(){
      this.$emit('frame9_close')
    }
  }
};
</script>

<style scoped>
.frame9 {
  width: calc(100% - 80px - 273px - 273px);
  height: 94px;
  background-color: #fff;
  position: fixed;
  bottom: 10px;
  left: 80px;
  display: flex;
  z-index: 999998;
  padding: 23px 273px;
}
.frame9_options1 {
  line-height: 94px;
}
.frame9_options1_img1 {
  width: 155px;
  height: 56px;
  vertical-align: middle;
}
.frame9_options2 {
  margin-left: 140px;
  font-size: 20px;
  line-height: 35px;

  color: #666666;
}
.frame9_options2_img1 {
  width: 254px;
  height: 23px;
  margin-top: 18px;
}
.frame9_options3 {
  display: flex;
}
.frame9_options3_part1 {
  margin-left: 210px;
}
.frame9_options3_part1_top {
  width: 156px;
  height: 45px;
  background-image: linear-gradient(135deg, #f8c54a 0%, #fcad2a 100%),
    linear-gradient(#ffffff, #ffffff);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 16px 2px rgba(252, 173, 42, 0.32);
  border-radius: 22px;
  font-size: 13px;
  line-height: 45px;
  color: #ffffff;
  /* text-align: center; */
}
.frame9_options3_part1_bottom {
  width: 156px;
  height: 45px;
  background-image: linear-gradient(135deg, #f8c54a 0%, #fcad2a 100%),
    linear-gradient(#ffffff, #ffffff);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 16px 2px rgba(252, 173, 42, 0.32);
  border-radius: 22px;
  font-size: 13px;
  line-height: 45px;
  color: #ffffff;
  /* text-align: center; */
  margin-top: 4px;
}
.frame9_options3_part1 img {
  width: 20px;
  height: 22px;
  vertical-align: middle;
  margin-right: 13px;
  margin-left: 22px;
}
.frame9_options3_part1 img:nth-child(2) {
  width: 19px;
  height: 22px;
}
.frame9_options3_part2 {
  width: 98px;
  height: 95px;
  line-height: 95px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 10px;
  border: solid 1px #fcad2a;
  margin-left: 30px;
}
.frame9_options3_img3 {
  width: 81px;
  height: 81px;
  vertical-align: middle;
}
.frame9_options3_part3{
    line-height: 94px;
    margin-left: 71px;
}
.frame9_options3_img4{
    width: 28px;
    height: 28px;
    vertical-align: middle;
}
</style>